<template>
  <div class="mobile_main shadow m-l-10 bg-white b-r-10 hide">
    <div class="mobile_title shadow w-100 bg-white text-center color-black">
      {{ title }}
    </div>
    <div class="df jc ac">
      <div class="mobile_box scroll" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "详情介绍",
    },
    content: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.mobile_main {
  width: 330px;
  height: 590px;
  border: 1px solid #eee;
}

.mobile_title {
  height: 39px;
  line-height: 39px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.mobile_box {
  width: 330px;
  height: 550px;
  background: white;
  padding: 5px 10px;
}

.mobile_box img {
  max-width: 100% !important;
}
</style>
